import 'styles/default.css';
import 'styles/fonts.css';
import 'styles/custom.css';
import * as CONFIG from 'config';
import { catalogOptions } from 'settings';
import { BrowserRouter, Routes, Route, HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CatalogProvider } from 'Catalog/Catalog.context';
import Head from 'Head';
import Frame from 'Catalog/Frame';
import ScrollTop from 'uitils/ScrollTop';
import WheelControl from 'Catalog/WheelControl';
import Dev_indicator from 'Component/Dev_indicator';
import { MotionConfig } from 'framer-motion';

function Catalog() {
  return (
    <CatalogProvider {...catalogOptions}>
      <Head />
      <ScrollTop />
      <WheelControl />
      {CONFIG.IS_DEV && <Dev_indicator />}
      <Frame />
    </CatalogProvider>
  );
}

function RouterType({ children, basename }) {
  return CONFIG.ROUTER_TYPE === 'hash' ? (
    <HashRouter basename={basename}>{children}</HashRouter>
  ) : (
    <BrowserRouter basename={basename}>{children}</BrowserRouter>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <RouterType basename={`${CONFIG.BASE_NAME}`}>
        <Routes>
          <Route
            path='/'
            element={<Catalog />}
          />

          <Route
            path='/:lang'
            element={<Catalog />}
          />
          <Route
            path='/:lang/:pageNum'
            element={<Catalog />}
          />
          <Route
            path='/:lang/:pageNum/:innerPageNum'
            element={<Catalog />}
          />
          <Route
            path='*'
            element={<Catalog />}
          />
        </Routes>
      </RouterType>
    </HelmetProvider>
  );
}
